export const BillerPartyData = {
  tabs: [
    {
      label: 'All Biller Party',
      id: 1,
    },
  ],
};
